import React from 'react'
import styled from 'styled-components'
import { ISegment } from '../types'
import Imaging from '../utils/imaging'

const Container = styled.div``

const SegmentImage = styled.img`
    width: 100%;
    display: block;
`

const SegmentVideo = styled.video`
    width: 100%;
    display: block;
`

type Props = {
    segment: ISegment
    soundEnabled?: boolean
    showVideo?: boolean
}

const SegmentPreview = ({ segment, showVideo = false, soundEnabled = false }: Props) => {
    let previewUrl = segment.preview_url
    let videoUrl = segment.video_url

    // If this clip has been trimmed, we also trim the preview thumbnail.
    if (
        segment.editParams &&
        (segment.editParams.trimmedStartTime > 0 || segment.editParams.trimmedEndTime !== segment.duration)
    ) {
        const start = segment.editParams.trimmedStartTime
        const duration = segment.editParams.trimmedEndTime - segment.editParams.trimmedStartTime
        const trimmedVideo = Imaging.trim(segment.video_url, start, duration)
        videoUrl = trimmedVideo
        previewUrl = Imaging.downsample(videoUrl, 5, 'gif', 250)
    }

    return (
        <Container>
            {showVideo ? (
                <SegmentVideo src={videoUrl} autoPlay={true} loop={true} muted={!soundEnabled} />
            ) : (
                <SegmentImage key={previewUrl} src={previewUrl} />
            )}
        </Container>
    )
}

export default SegmentPreview
